import { createFileRoute, Link, notFound, Outlet } from '@tanstack/react-router'
import { EmptyState } from '@/components/empty-state'
import { Button } from '@/components/ui/button'
import { findSite, isReservedSegment, sitesQuery } from '@/lib/queries'

export const Route = createFileRoute('/_app/$org/$host')({
  beforeLoad: ({ params }) => {
    if (isReservedSegment(params.host)) throw notFound()
  },
  loader: async ({ context, params }) => {
    const { sites } = await context.queryClient.ensureQueryData(sitesQuery)
    if (!findSite(sites, params.host)) throw notFound()
  },
  component: Outlet,
  notFoundComponent: SiteNotFound,
})

function SiteNotFound() {
  const { org, host } = Route.useParams()
  return (
    <div className="rounded-lg border border-border bg-card">
      <EmptyState
        title="Site not found"
        description={`${host} is not one of the sites in this workspace.`}
        action={
          <Button asChild size="sm" variant="outline">
            <Link to="/$org/sites" params={{ org }}>
              Back to sites
            </Link>
          </Button>
        }
      />
    </div>
  )
}
